
import { SPORTSBOOKS, type SportsbookId } from "@/lib/sportsbook-registry";

export const PLATFORM_COLORS: Record<SportsbookId, string> = Object.fromEntries(
  Object.values(SPORTSBOOKS)
    .filter(b => b.columnKey)
    .map(b => [b.id, b.colorHex])
) as Record<SportsbookId, string>;

export const DEFAULT_ODDS_BY_COLUMN: Record<string, number> = Object.fromEntries(
  Object.values(SPORTSBOOKS)
    .filter(b => b.columnKey && typeof b.defaultOdds === 'number')
    .map(b => [b.columnKey!, b.defaultOdds!])
);

export const PLATFORM_COLUMN_KEY: Record<SportsbookId, string> = Object.fromEntries(
  Object.values(SPORTSBOOKS)
    .filter(b => b.columnKey)
    .map(b => [b.id, b.columnKey!])
) as Record<SportsbookId, string>;

export const SPORTSBOOK_COLUMNS = new Set<string>(
  Object.values(SPORTSBOOKS)
    .filter(b => b.columnKey)
    .map(b => b.columnKey!)
);
